import Find from "pages/FindSection"
import PurchaseRegister from "pages/Purchase/Register"
import Journal from "pages/Finance/Journal"
import OpeningBalance from "pages/Accounts/Transaction/OpeningBalance"
import PurchaseOrder from "pages/Purchase/Transaction/PurchaseOrder"
import ClosePurchase from "pages/Purchase/Transaction/ClosePurchase"
import EditPurchaseOrder from "pages/Purchase/Transaction/PurchaseOrder/Edit"
import GeneralEntry from "pages/Finance/Transaction/GeneralEntry"
import Dashboard from "pages/Purchase/Report/Dashboard"
import ApproveBills from "pages/Purchase/Transaction/ApproveBills"
import DepositVendor from "pages/Purchase/Transaction/DepositVendor"
import EditDepositVendor from "pages/Purchase/Transaction/DepositVendor/Edit"
import EnterBill from "pages/Purchase/Transaction/EnterBill"
import EditEnterBill from "pages/Purchase/Transaction/EnterBill/Edit"
import CreatePaymentBill from "pages/Purchase/Transaction/PaymentBill/Create"
import UpdatePaymentBillPage from "pages/Purchase/Transaction/PaymentBill/UpdatePage"
import EditRejectItem from "pages/Purchase/Transaction/RejectItem/Edit"
import RejectItem from "pages/Purchase/Transaction/RejectItem"
import DataSource from "pages/Purchase/Transaction/ReceivedReject/DataSource"
import ReceivedReject from "pages/Purchase/Transaction/ReceivedReject"
import ReceivedRejectAdjustment from "pages/Purchase/Transaction/ReceivedRejectAdjustment"
import ReceivedRejectMoney from "pages/Purchase/Transaction/ReceivedRejectMoney"
import RecordReject from "pages/Purchase/Transaction/RecordReject"
import EditRecordReject from "pages/Purchase/Transaction/RecordReject/Edit"
import ListBillAdjustment from "pages/Purchase/Transaction/AdjustmentFreightBill/ListBillAdjustment"
import CreateBillAdjustment from "pages/Purchase/Transaction/AdjustmentFreightBill/CreateBillAdjustment"
import type { RouteType } from "types"
import ApprovePo from "pages/Purchase/Transaction/ApprovePo"
import ApproveDepoVendor from "pages/Purchase/Transaction/ApproveDepoVendor"
import ApproveReject from "pages/Purchase/Transaction/ApproveReject"
import ApprovePaymentBill from "pages/Purchase/Transaction/ApprovePaymentBill"
import EditBill from "pages/Purchase/Transaction/EditBill"
import DetailEditBill from "pages/Purchase/Transaction/EditBill/Detail"
import ApproveReceivedRejected from "pages/Purchase/Transaction/ApproveReceivedRejected"
import { CreateBillService } from "pages/Purchase/Transaction/BillService/CreateBillService"
import { EditBillService } from "pages/Purchase/Transaction/BillService/EditBillService"
import { ListBillServiceApproval } from "pages/Purchase/Transaction/BillServiceApproval/ListBillServiceApproval"
import { UpdatePaymentBillService } from "pages/Purchase/Transaction/PaymentBillService/UpdatePaymentBillService"
import { CreatePaymentBillService } from "pages/Purchase/Transaction/PaymentBillService/CreatePaymentBillService"
import { PaymentBillServiceApproval } from "pages/Purchase/Transaction/PaymentBillServiceApproval/PaymentBillServiceApproval"
import { PERMISION } from "security"
import CreateDirectBill from "pages/Purchase/Transaction/DirectBill/CreateDirectBill"
import EditDirectBill from "pages/Purchase/Transaction/DirectBill/EditDirectBill"


export const purchaseRoutes: RouteType[] = [
  {
    path: "/purchase/register",
    element: <PurchaseRegister />, 
    permission: PERMISION.PURCHASES.REGISTER.PERMISION
  },
  {
    path: "/purchase/transaction/opening-balance",
    element: <OpeningBalance />,
    permission: "AT01"
  },
  {
    path: "/purchase/transaction/purchase-order",
    element: <PurchaseOrder />,
    permission: 
      PERMISION.INVENTORY.REGISTER.REQUIEST_FROM.UPDATE || 
      PERMISION.INVENTORY.REPORT.ITEM_DETAIL_STOCK_GLOBAL.UPDATE || 
      PERMISION.PURCHASES.TRANSACTION.CREATE_PURCHASE_ORDER.CREATE
  },
  {
    path: "/purchase/transaction/bill-service",
    element: <CreateBillService />,
    permission: PERMISION.PURCHASES.TRANSACTION.CREATE_BILL_SERVICE.CREATE
  },
  {
    path: "/purchase/transaction/direct-bill",
    element: <CreateDirectBill />,
    permission: PERMISION.PURCHASES.TRANSACTION.CREATE_DIRECT_BILL.CREATE
  },
  {
    path: "/purchase/transaction/purchase-order/:id",
    element: <EditPurchaseOrder />,
    permission: 
      PERMISION.PURCHASES.REGISTER.BY_DATE_RANGE.UPDATE || 
      PERMISION.PURCHASES.REGISTER.BY_CARD.UPDATE || 
      PERMISION.PURCHASES.REGISTER.BY_LOCATION.UPDATE ||
      PERMISION.PURCHASES.REGISTER.BY_REFERENCE_ID.UPDATE
  },
  {
    path: "/purchase/transaction/bill-service/:id",
    element: <EditBillService />,
    permission: PERMISION.PURCHASES.REGISTER.BILLS_ITEM.UPDATE
  },
  {
    path: "/purchase/transaction/enter-bills/:id",
    element: <EnterBill />,
    permission: PERMISION.PURCHASES.REGISTER.BILLS_ITEM.UPDATE
  },
  {
    path: "/purchase/transaction/enter-bills/:id/edit/:bill_id",
    element: <EditEnterBill />,
    permission: PERMISION.PURCHASES.REGISTER.BILLS_ITEM.UPDATE || PERMISION.PURCHASES.REGISTER.AGED_PAYABLE.UPDATE
  },
  {
    path: "/purchase/report/dashboard",
    element: <Dashboard />,
    permission: PERMISION.PURCHASES.REPORT.DASHBOARD.READ
  },
  {
    path: "/purchase/transaction/approve-bills",
    element: <ApproveBills />,
    permission: PERMISION.PURCHASES.TRANSACTION.APPROVAL_BILLS.READ
  },
  {
    path: "/purchase/transaction/approve-po",
    element: <ApprovePo />, 
    permission: PERMISION.PURCHASES.TRANSACTION.APPROVAL_PO.READ
  },
  {
    path: "/purchase/transaction/approve-bil-service",
    element: <ListBillServiceApproval />, 
    permission: PERMISION.PURCHASES.TRANSACTION.APPROVAL_PAYMENT_BILL_SERVICE.READ
  },
  {
    path: "/purchase/transaction/approve-depo-vendor",
    element: <ApproveDepoVendor />,
    permission: PERMISION.PURCHASES.TRANSACTION.APPROVAL_DEPOSIT.READ
  },
  {
    path: "/purchase/transaction/approve-reject",
    element: <ApproveReject />,
    permission: PERMISION.PURCHASES.TRANSACTION.APPROVAL_REJECT.READ
  },
  {
    path: "/purchase/journal",
    element: <Journal />,
    permission: PERMISION.PURCHASES.JOURNAL.PERMISION
  },
  {
    path: "/purchase/find",
    element: <Find />,
    permission: PERMISION.PURCHASES.FIND.PERMISION
  },
  {
    path: "/purchase/transaction/general-entry",
    element: <GeneralEntry />,
    permission: "AT02"
  },
  {
    path: "/purchase/transaction/deposit-vendor/:purchase_order_id",
    element: <DepositVendor />,
    permission: "AT02" // belum diubah
  },
  {
    path: "/purchase/transaction/deposit-vendor/edit/:deposit_vendor_id",
    element: <EditDepositVendor />,
    permission: "AT02" // belum diubah
  },
  {
    path: "/purchase/transaction/payment-bill/:bill_id",
    element: <CreatePaymentBill />,
    permission: "AT02" // belum diubah
  },
  {
    path: "/purchase/transaction/payment-bill/edit/:payment_bill_id",
    element: <UpdatePaymentBillPage />,
    permission: "AT02" // belum diubah
  },
  {
    path: "/purchase/transaction/payment-bill-service/:id",
    element: <CreatePaymentBillService />,
    permission: "AT02" // belum diubah
  },
  {
    path: "/purchase/transaction/payment-bill-service/edit/:id",
    element: <UpdatePaymentBillService />,
    permission: "AT02" // belum diubah
  },
  {
    path: "/purchase/transaction/reject-item/:purchase_order_id/:bill_id",
    element: <RejectItem />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/transaction/reject-item/edit/:bill_id/:reject_id",
    element: <EditRejectItem />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/transaction/approve-payment-bill",
    element: <ApprovePaymentBill />,
    permission: PERMISION.PURCHASES.TRANSACTION.APPROVAL_PAYMENT_BILL.READ
  },
  {
    path: "/purchase/transaction/approve-payment-bill-service",
    element: <PaymentBillServiceApproval />,
    permission: PERMISION.PURCHASES.TRANSACTION.APPROVAL_PAYMENT_BILL_SERVICE.READ
  },
  {
    path: "/purchase/transaction/record-reject",
    element: <RecordReject />,
    permission: PERMISION.PURCHASES.TRANSACTION.CREATE_REJECTED_RECORDS.READ
  },
  {
    path: "/purchase/transaction/record-reject/:id",
    element: <EditRecordReject />,
    permission: PERMISION.PURCHASES.TRANSACTION.CREATE_REJECTED_RECORDS.UPDATE
  },
  {
    path: "/purchase/transaction/close-purchase/:id",
    element: <ClosePurchase />,
    permission: "PT05" // BELUM
  },
  {
    path: "/purchase/transaction/edit-bill",
    element: <EditBill />,
    permission: PERMISION.PURCHASES.TRANSACTION.EDIT_BILL.READ
  },
  {
    path: "/purchase/transaction/edit-bill/:id",
    element: <DetailEditBill />,
    permission: PERMISION.PURCHASES.TRANSACTION.EDIT_BILL.UPDATE
  },
  {
    path: "/purchase/transaction/received-reject/data-source/:id",
    element: <DataSource />,
    permission: "PT12" // BELUM
  },
  {
    path: "/purchase/transaction/received-reject/:id",
    element: <ReceivedReject />,
    permission: "PT12" // BELUM
  },
  {
    path: "/purchase/transaction/received-reject-money/:id",
    element: <ReceivedRejectMoney />,
    permission: "PT12" // BELUM
  },
  {
    path: "/purchase/transaction/received-reject-adjustment/:id",
    element: <ReceivedRejectAdjustment />,
    permission: "PT12" // BELUM
  },
  {
    path: "/purchase/transaction/approve-received-rejected",
    element: <ApproveReceivedRejected/>,
    permission: PERMISION.PURCHASES.TRANSACTION.APPROVAL_REPLACEMENT_RECEIPT.READ
  },
  {
    path: "/purchase/transaction/adjustment-freight/list",
    element: <ListBillAdjustment/>,
    permission: PERMISION.PURCHASES.TRANSACTION.ADJUSTMENT_FREIGHT_BILL.READ
  },
  {
    path: "/purchase/transaction/adjustment-freight/:id",
    element: <CreateBillAdjustment />,
    permission: PERMISION.PURCHASES.TRANSACTION.ADJUSTMENT_FREIGHT_BILL.UPDATE
  },
  {
    path: "/purchase/transaction/direct-bill/edit/:bill_id",
    element: <EditDirectBill />,
    permission: PERMISION.PURCHASES.TRANSACTION.CREATE_DIRECT_BILL.UPDATE
  },
  {
    path: "/purchase/transaction/purchase-register",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/aging-summary",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/ageng-detail",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/purchase-summary",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/purchase-detail",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/analyse-purchase-periode",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/analyse-purchase-comparation",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/analyse-purchase-monthly",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/vendor-purchase-summary",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/vendor-purchase-detail",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/bill-summary",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/bill-detail",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/supplier-payment",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/supplier-payment-history",
    element: <div />,
    permission: "PT" // BELUM
  },
  {
    path: "/purchase/report/purchase-payable-journal",
    element: <div />,
    permission: "PT" // BELUM
  }
]